import { AmenityV2Enum } from '@components/_shared/amenityV2/constants';
import { AmenityV2Icon } from '@assets/images/amenitiesV2';

export const getAmenityV2Icon = (amenity: AmenityV2Enum) => {
  switch (amenity) {
    case AmenityV2Enum.bathtub:
      return AmenityV2Icon.bathtub;
    case AmenityV2Enum.shampoo:
      return AmenityV2Icon.shampoo;
    case AmenityV2Enum.essentials:
      return AmenityV2Icon.essentials;
    case AmenityV2Enum.dryer:
      return AmenityV2Icon.dryer;
    case AmenityV2Enum.hangers:
      return AmenityV2Icon.hangers;
    case AmenityV2Enum.towels_provided:
      return AmenityV2Icon.towels_provided;
    case AmenityV2Enum.washer:
      return AmenityV2Icon.washer;
    case AmenityV2Enum.cable_tv:
      return AmenityV2Icon.cable_tv;
    case AmenityV2Enum.tv:
      return AmenityV2Icon.tv;
    case AmenityV2Enum.stereo_system:
      return AmenityV2Icon.stereo_system;
    case AmenityV2Enum.air_conditioning:
      return AmenityV2Icon.air_conditioning;
    case AmenityV2Enum.heating:
      return AmenityV2Icon.heating;
    case AmenityV2Enum.indoor_fireplace:
      return AmenityV2Icon.indoor_fireplace;
    case AmenityV2Enum.fire_extinguisher:
      return AmenityV2Icon.fire_extinguisher;
    case AmenityV2Enum.first_aid_kit:
      return AmenityV2Icon.first_aid_kit;
    case AmenityV2Enum.smoke_detector:
      return AmenityV2Icon.smoke_detector;
    case AmenityV2Enum.desk:
      return AmenityV2Icon.desk;
    case AmenityV2Enum.wireless_internet:
      return AmenityV2Icon.wireless_internet;
    case AmenityV2Enum.laptop_friendly_workspace:
      return AmenityV2Icon.laptop_friendly_workspace;
    case AmenityV2Enum.coffee_maker:
      return AmenityV2Icon.coffee_maker;
    case AmenityV2Enum.cookware:
      return AmenityV2Icon.cookware;
    case AmenityV2Enum.dishes_and_silverware:
      return AmenityV2Icon.dishes_and_silverware;
    case AmenityV2Enum.dishwasher:
      return AmenityV2Icon.dishwasher;
    case AmenityV2Enum.kitchen:
      return AmenityV2Icon.kitchen;
    case AmenityV2Enum.kettle:
      return AmenityV2Icon.kettle;
    case AmenityV2Enum.microwave:
      return AmenityV2Icon.microwave;
    case AmenityV2Enum.oven:
      return AmenityV2Icon.oven;
    case AmenityV2Enum.refrigerator:
      return AmenityV2Icon.refrigerator;
    case AmenityV2Enum.stove:
      return AmenityV2Icon.stove;
    case AmenityV2Enum.toaster:
      return AmenityV2Icon.toaster;
    case AmenityV2Enum.private_pool:
      return AmenityV2Icon.private_pool;
    case AmenityV2Enum.garden_or_backyard:
      return AmenityV2Icon.garden_or_backyard;
    case AmenityV2Enum.patio_or_balcony:
      return AmenityV2Icon.patio_or_balcony;
    case AmenityV2Enum.bbq_grill:
      return AmenityV2Icon.bbq_grill;
    case AmenityV2Enum.ev_charger:
      return AmenityV2Icon.ev_charger;
    case AmenityV2Enum.free_parking_on_premises:
      return AmenityV2Icon.free_parking_on_premises;
    case AmenityV2Enum.doorman:
      return AmenityV2Icon.doorman;
    case AmenityV2Enum.tub_with_shower_bench:
      return AmenityV2Icon.tub_with_shower_bench;
    case AmenityV2Enum.elevator:
      return AmenityV2Icon.elevator;
    case AmenityV2Enum.gym:
      return AmenityV2Icon.gym;
    case AmenityV2Enum.hot_tub:
      return AmenityV2Icon.hot_tub;
    case AmenityV2Enum.sauna:
      return AmenityV2Icon.sauna;
    default:
      return null;
  }
};
